// Swiss score block: oversized mono numeral + hairline progress rule.
export default function ScoreCircle({ score, max, testId }) {
  const pct = Math.max(0, Math.min(1, score / max));
  return (
    <div data-testid={testId} className="w-full max-w-[320px]">
      <div className="flex items-end gap-3">
        <div className="numeral text-[7rem] sm:text-[8.5rem] text-foreground" data-testid="score-value">
          {Math.round(score)}
        </div>
        <div className="font-mono-fig text-xl text-muted-foreground pb-3">/{max}</div>
      </div>
      <div className="mt-5 h-[3px] w-full bg-foreground/10">
        <div className="h-full bg-signal transition-[width] duration-700 ease-out" style={{ width: `${pct * 100}%` }} />
      </div>
      <div className="mt-2 flex justify-between overline">
        <span>0</span><span>{max}</span>
      </div>
    </div>
  );
}
